import {ControlModel} from 'src/app/core/models/control.model';

export class BuildingBlockItemModel {
  public type;
  public controls: Array<ControlModel> = [];
  public actionControls: Array<ControlModel> = [];
  public validate: boolean;
  public tableInfo: {columns: Array<ControlModel>, dbTable: string} = {columns: [], dbTable: ''};
}
